export default __webpack_public_path__ + "static/alex-hanbury-92881e562e9300053c580516bd43ed56.png";